import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { BatchJob, UnmatchedContainer } from '../../shared/models/batch.model';

interface DialogData {
  batchJob: BatchJob
}

@Component({
  host: { 'test-id': 'batch-job-dialog' },
  selector: 'batch-job-dialog',
  styleUrls: ['./batch-job-dialog.component.scss'],
  template: `
    <h1 mat-dialog-title>{{ 'batchJobDialog.title' | translate }}</h1>
    <div mat-dialog-content>
      <div class="container-bucket" [matTooltip]="getLabelTooltip(batchJob.matched)" matTooltipPosition="left">
        <span>{{ batchJob.matched.length }}</span>
        <span>{{ 'batchJobDialog.matched' | translate }}</span>
      </div>
      <div *ngIf="batchJob.not_matched.length > 0" [matTooltip]="getLabelTooltip(batchJob.not_matched)"
        matTooltipPosition="left" class="container-bucket error-case">
        <span>{{ batchJob.not_matched.length }}</span>
        <span>{{ 'batchJobDialog.notMatched' | translate }}</span>
      </div>
      <div *ngIf="batchJob.ambiguous.length > 0" [matTooltip]="getLabelTooltip(batchJob.ambiguous)"
        matTooltipPosition="left" class="container-bucket error-case">
        <span>{{ batchJob.ambiguous.length }}</span>
        <span>{{ 'batchJobDialog.ambiguous' | translate }}</span>
      </div>
      <div *ngIf="batchJob.improper_permissions.length > 0" [matTooltip]="getLabelTooltip(batchJob.improper_permissions)"
        matTooltipPosition="left" class="container-bucket error-case">
        <span>{{ batchJob.improper_permissions.length }}</span>
        <span>{{ 'batchJobDialog.improperPermissions' | translate }}</span>
      </div>
      <p>{{ 'batchJobDialog.note' | translate }}</p>
    </div>
    <div mat-dialog-actions align="end">
      <button test-id="cancel-button" mat-stroked-button [mat-dialog-close]="false">
        {{ (canRun ? 'common.actions.cancel' : 'common.actions.close') | translate }}</button>
      <button *ngIf="canRun" test-id="run-button" mat-flat-button color="primary"
        [mat-dialog-close]="true">{{ 'batchJobDialog.buttons.run' | translate }}</button>
    </div>
  `,
})
export class BatchJobDialog {
  batchJob: BatchJob = this.data.batchJob

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    ref: MatDialogRef<BatchJobDialog, boolean>,
  ) {
    ref.disableClose = true;
  }

  get canRun(): boolean {
    return this.batchJob.matched.length > 0;
  }

  getLabelTooltip(bucket: UnmatchedContainer[]): string {
    return bucket.map(container => container.label ?? container._id).join('\n');
  }
}
